export const UI_TEST_ROUTE_PATH = '/admin/test-thao-tac-ui' as const

export const UI_TEST_RUN_ROUTE_PATH = '/admin/test-thao-tac-ui/chay/:scenarioId' as const

export const uiTestRunPath = (scenarioId: string): string =>
  `/admin/test-thao-tac-ui/chay/${encodeURIComponent(scenarioId)}`
